<template>
  <v-card flat>
    <v-card-text class="pa-0">
      <v-container>
        <v-row v-if="enableAttributeNames.includes('oil')">
          <v-col cols="3" class="pa-0 mt-4">
            <!-- OIL（運用上の介入レベル） -->
            <v-text-field
              v-if="readonly"
              :value="oilName"
              label="OIL（運用上の介入レベル）"
              readonly
              hide-details
            ></v-text-field>
            <v-select
              v-else
              ref="oil"
              v-model="innerOil"
              :items="oils"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="OIL（運用上の介入レベル）"
              item-text="name"
              item-value="code"
              :rules="[validationRules.required()]"
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-row v-if="enableAttributeNames.includes('fixed_phrase_title')">
          <v-col cols="9" class="px-0">
            <!-- 件名 -->
            <v-text-field
              v-if="
                !readonly || enableAttributeLengths['fixed_phrase_title'] <= 50
              "
              ref="fixed_phrase_title"
              :value="fixed_phrase_title"
              @input="
                $emit('update:fixed_phrase_title', $event);
                $nextTick(
                  () => isAlwaysRequired || $refs.fixed_phrase.validate(true)
                );
              "
              label="件名"
              :placeholder="
                readonly ? config.PLACEHOLDER_SP : config.PLACEHOLDER_INPUT
              "
              :outlined="!readonly"
              :readonly="readonly"
              :maxlength="enableAttributeLengths['fixed_phrase_title']"
              :rules="[
                fixedPhraseRequiredRule,
                validationRules.maxLength(
                  enableAttributeLengths['fixed_phrase_title']
                )
              ]"
              counter
            ></v-text-field>
            <v-textarea
              v-else
              ref="fixed_phrase_title"
              :value="fixed_phrase_title"
              label="件名"
              :placeholder="config.PLACEHOLDER_SP"
              :maxlength="enableAttributeLengths['fixed_phrase_title']"
              rows="3"
              readonly
              counter
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="enableAttributeNames.includes('reason')">
          <v-col cols="9" class="px-0">
            <!-- 発令・解除理由 -->
            <v-text-field
              v-if="!readonly"
              ref="reason"
              :value="reason"
              @input="$emit('update:reason', $event)"
              label="発令・解除理由"
              :placeholder="
                readonly ? config.PLACEHOLDER_SP : config.PLACEHOLDER_INPUT
              "
              :outlined="!readonly"
              :readonly="readonly"
              :maxlength="enableAttributeLengths['reason']"
              :rules="[
                validationRules.maxLength(enableAttributeLengths['reason'])
              ]"
              counter
            ></v-text-field>
            <v-textarea
              v-else
              ref="reason"
              :value="reason"
              label="発令・解除理由"
              :placeholder="config.PLACEHOLDER_SP"
              :maxlength="enableAttributeLengths['reason']"
              rows="3"
              readonly
              counter
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="enableAttributeNames.includes('fixed_phrase')">
          <v-col cols="9" class="px-0">
            <!-- 本文/避難行動指針 -->
            <v-textarea
              ref="fixed_phrase"
              :value="fixed_phrase"
              @input="
                $emit('update:fixed_phrase', $event);
                $nextTick(
                  () =>
                    isAlwaysRequired || $refs.fixed_phrase_title.validate(true)
                );
              "
              :label="fixedPhraseLabel"
              :placeholder="
                readonly ? config.PLACEHOLDER_SP : config.PLACEHOLDER_INPUT
              "
              :outlined="!readonly"
              :readonly="readonly"
              :maxlength="enableAttributeLengths['fixed_phrase']"
              :rules="[
                fixedPhraseRequiredRule,
                validationRules.maxLength(
                  enableAttributeLengths['fixed_phrase']
                )
              ]"
              counter
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="enableAttributeNames.includes('link_url')">
          <v-col cols="9" class="px-0">
            <!-- 関連するホームページ（URL） -->
            <v-text-field
              v-if="!readonly"
              ref="link_url"
              :value="link_url"
              @input="
                $emit('update:link_url', $event);
                $emit('update:urlPreviewed', !$event);
              "
              label="関連するホームページ（URL）"
              :placeholder="
                readonly ? config.PLACEHOLDER_SP : config.PLACEHOLDER_INPUT
              "
              :outlined="!readonly"
              :readonly="readonly"
              :maxlength="enableAttributeLengths['link_url']"
              :rules="[
                validationRules.maxLength(enableAttributeLengths['link_url'])
              ]"
              counter
            ></v-text-field>
            <v-textarea
              v-else
              ref="link_url"
              :value="link_url"
              label="関連するホームページ（URL）"
              :placeholder="config.PLACEHOLDER_SP"
              :maxlength="enableAttributeLengths['link_url']"
              rows="3"
              readonly
              counter
            ></v-textarea>
          </v-col>
          <v-col class="px-0">
            <v-btn
              color="primary"
              class="ma-2"
              :href="link_url"
              target="_blank"
              :disabled="!link_url"
              @click="$emit('update:urlPreviewed', true)"
            >
              {{
                (readonly && !!link_url) || (!!link_url && urlPreviewed)
                  ? "プレビュー済"
                  : "プレビュー"
              }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="enableAttributeNames.includes('suppl')">
          <v-col cols="9" class="px-0">
            <!-- 補足情報 -->
            <v-text-field
              v-if="!readonly"
              ref="suppl"
              :value="suppl"
              @input="$emit('update:suppl', $event)"
              label="補足情報"
              :placeholder="
                readonly ? config.PLACEHOLDER_SP : config.PLACEHOLDER_INPUT
              "
              :outlined="!readonly"
              :readonly="readonly"
              :maxlength="enableAttributeLengths['suppl']"
              :rules="[
                validationRules.maxLength(enableAttributeLengths['suppl'])
              ]"
              counter
            ></v-text-field>
            <v-textarea
              v-else
              ref="suppl"
              :value="suppl"
              label="補足情報"
              :placeholder="config.PLACEHOLDER_SP"
              :maxlength="enableAttributeLengths['suppl']"
              rows="3"
              readonly
              counter
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import config from "@/js/const";

export default {
  data: () => ({
    config
  }),

  props: {
    // 読み取り専用かどうかを示す値
    readonly: Boolean,
    // 件名と本文が常に必須かどうかを示す値
    isAlwaysRequired: Boolean,
    // バリデーションルール
    validationRules: Object,
    // 有効な属性名
    enableAttributes: Array,
    // OILリスト
    oils: Array,
    // OIL（運用上の介入レベル）
    oil: String,
    // 件名
    fixed_phrase_title: String,
    // 発令・解除理由
    reason: String,
    // 避難行動指針
    evac_behavior: String,
    // 補足情報
    suppl: String,
    // 本文
    fixed_phrase: String,
    // 関連するホームページ（URL）
    link_url: String,
    // URLプレビューを押したかどうかを示す値
    urlPreviewed: Boolean
  },

  computed: {
    /**
     * OILセレクトボックスの双方向バインド変数
     * OILの初期値が空文字列の場合はデフォルト値を設定する。
     */
    innerOil: {
      get() {
        if (!this.oil) {
          this.$emit("update:oil", this.oils.find(elem => elem.isDefault).code);
        }

        return this.oil;
      },
      set(newValue) {
        this.$emit("update:oil", newValue);
      }
    },

    /**
     * 有効な属性名のリスト
     */
    enableAttributeNames() {
      return this.enableAttributes.map(({ name }) => name);
    },

    /**
     * 有効な属性名の桁数オブジェクト
     */
    enableAttributeLengths() {
      return Object.fromEntries(
        this.enableAttributes.map(({ name, length }) => [name, length])
      );
    },

    /**
     * 本文のラベル
     */
    fixedPhraseLabel() {
      return this.enableAttributes.find(({ name }) => name === "fixed_phrase")
        .label;
    },

    /**
     * OIL名
     */
    oilName() {
      return this.oils.find(elem => elem.code === this.oil)?.name ?? "";
    },

    /**
     * 件名または本文の必須チェックルール
     */
    fixedPhraseRequiredRule() {
      const fixed_phrase_title = this.fixed_phrase_title;
      const fixed_phrase = this.fixed_phrase;

      if (this.isAlwaysRequired) {
        return this.validationRules.required();
      }

      return v =>
        (!fixed_phrase_title && !fixed_phrase) ||
        this.validationRules.required()(v);
    }
  }
};
</script>
